"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5847,2416,8512,9771,2366],{

/***/ 34160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CollectionsSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41410);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1860);
/* harmony import */ var _ReadMoreText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68208);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23158);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83974);
/* harmony import */ var _articles_ArticleTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54106);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75547);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);


// Import Swiper React components








function CollectionsSection(param) {
    var collectionsList = param.collectionsList, app = param.app, enableReadMore = param.enableReadMore, builder = param.builder, app_data = param.app_data;
    var sliderPerViewHandler = function sliderPerViewHandler() {
        if (pageContext.isMobile) {
            return 1;
        } else {
            return collectionItemsToShow;
        }
    };
    var builderCollectionsViewType = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_view_type");
    });
    var customViewType = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(builderCollectionsViewType);
    var builderCollectionsBackgroundColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_background_color");
    });
    var showCollectionsInHomepage = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_show_in_homepage");
    });
    var showCollectionsTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_title");
    });
    var showCollectionsSubtitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_subtitle");
    });
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .page */ .M);
    var collectionItemsToShow = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_items");
    });
    var showAllButton = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_show_all_button");
    });
    var useCollectionTitleInButton = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_6__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_collections_single_button");
    });
    var textColor = function() {
        if (app.builder.builder_homepage_collections_dark_mode != undefined && app.builder.builder_homepage_collections_dark_mode != 0) {
            return "text-light-color";
        }
        return "";
    };
    var prepareCollections = function() {
        var articles = [];
        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidArray */ .Z.isValidArray(collectionsList.collections) && collectionsList.collections.forEach(function(item, index) {
            // console.log("collectionsList", item, index)
            var tempString2;
            var tempString1 = item.title;
            if (useCollectionTitleInButton == 1) {
                tempString2 = item.properties_count + " " + tempString1;
            } else {
                tempString2 = item.properties_count + " villas";
            }
            var articleItem = {
                id: item.id,
                title: builderCollectionsViewType == 403 || builderCollectionsViewType == 400 || builderCollectionsViewType == 404 || builderCollectionsViewType == 405 || builderCollectionsViewType == 406 ? tempString2 : tempString1,
                subtitle: builderCollectionsViewType == 403 || builderCollectionsViewType == 400 || builderCollectionsViewType == 404 || builderCollectionsViewType == 405 || builderCollectionsViewType == 406 ? tempString1 : tempString2,
                // body: item.properties_count + " villas",
                // description: item.properties_count + " villas",
                loggiaUrl: "/properties/index?collections=" + item.id,
                redirect_url: "/properties/index?collections=" + item.id,
                image: item.image_thumb,
                has_description: 1
            };
            articles.push(articleItem);
        });
        // {
        //   "id": 741,
        //     "title": "Car, bike, bicycle rental",
        //     "body": "Book your vehicle to explore Crete!",
        //     "description": "<p dir=\"ltr\">Explore the island and its beautiful beaches at your own leisure. Make the most of this experience by exploring the area, on a bicycle, on a motorbike or by car. For destinations that haven’t been discovered, that hide below steep hills and lush trails along the rich coastline of the island of Crete, a rented car is the best way for you to get to know the place better. We provide you with every possible transport that can cope with your necessities and preferences.</p><p dir=\"ltr\">We want to make sure you have an amazing experience on your holiday. So, whether you want to drive through the mountains to marvel at the spectacular views, grab your bucket and spade and make sandcastles on the beach, or just a quick and easy trip to the supermarket for the essentials, hiring a car gives you the flexibility and freedom to do just that.&nbsp;</p><p dir=\"ltr\">Renting a car is essential when choosing a villa. It gives you the opportunity to explore and discover the hidden treasures of the regions of Crete and organize your program as you wish. The Holiways team can provide you with the vehicle of your choice, offering our customers a wide range of vehicle models available to meet their personal requirements.</p><p dir=\"ltr\">Don’t hesitate to trust us and our services for more tranquil and without-worried vacations.</p><p><b>Type of vehicle:</b><br>Car renting (Sedan, Minivan, SUV, Cabrio)<br>Luxury car<br>Scooter|<br>Motorbike<br>Bike<br>Quad bikes<br>Other vehicles of your preference</p><p><b>Benefits:</b><br>Professional partners<br>Liable vehicles<br>Arranged to pick up/drop off time<br>Mobility during your holidays<br>Discover more. Travellers are limited when travelling around with public transport<br>Feel like a local</p>",
        //     "image": "https://cdn.loggia.gr/lodgeContent/75f07ca88289cf1e72c66b478d3adefd.jpg",
        //     "loggiaUrl": "/car-rental",
        //     "has_description": 1
        // }
        return articles;
    };
    return showCollectionsInHomepage == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            id: "properties-collections",
            className: (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isHexColor */ .Z.isHexColor(builderCollectionsBackgroundColor) ? "bg-white" : "") + (customViewType ? " p-b-80" : ""),
            style: {
                background: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isHexColor */ .Z.isHexColor(builderCollectionsBackgroundColor) ? builderCollectionsBackgroundColor : ""
            },
            children: [
                collectionsList.title != null && collectionsList.title.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-5 pb-4 p-t-100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "container text-center sm-p-t-20",
                                children: [
                                    showCollectionsTitle != null && showCollectionsTitle.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "mt-1 fw-normal m-b-0 " + textColor(),
                                        children: showCollectionsTitle
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                    showCollectionsSubtitle != null && showCollectionsSubtitle.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "block-title mb-0 m-t-0 " + textColor(),
                                        children: showCollectionsSubtitle
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                ]
                            })
                        })
                    })
                }),
                customViewType ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_articles_ArticleTypes__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        type: "collections",
                        textColor: textColor(),
                        backgroundColor: "",
                        content: "",
                        articles: prepareCollections(),
                        app_data: app_data,
                        builder: builder,
                        viewType: builderCollectionsViewType,
                        articlesCategories: null,
                        articlesLimit: null,
                        itemClassName: "design-box-collection",
                        slidesPerView: collectionItemsToShow
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "panel panel-transparent",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "panel-body p-t-20 p-l-20 p-r-20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row clearfix p-b-40 dot-navigation",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                                            className: "p-b-40",
                                            speed: 1000,
                                            loop: true,
                                            navigation: false,
                                            slidesPerView: sliderPerViewHandler(),
                                            autoplay: false,
                                            spaceBetween: 20,
                                            pagination: {
                                                clickable: true
                                            },
                                            children: collectionsList.collections.map(function(collection, key) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "row clearfix m-b-5 design-box-collection",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "col-sm-12",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "card social-card share full-width",
                                                                style: {
                                                                    // border: "none",
                                                                    // borderRadius: "10px",
                                                                    // boxShadow: "0px 0px 8px #CCC",
                                                                    marginLeft: "1px",
                                                                    overflow: "hidden"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "card-content",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "properties/index?collections=" + collection.id,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                alt: "Social post",
                                                                                src: collection.image_thumb
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "card-footer clearfix",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "text-uppercase hint-text bold small-text",
                                                                                children: [
                                                                                    collection.properties_count,
                                                                                    "+ properties"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "bold",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    href: "properties/index?collections=" + collection.id,
                                                                                    className: "text-master",
                                                                                    children: collection.title
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "m-b-30",
                                                                                children: enableReadMore ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ReadMoreText__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                                    letters: 120,
                                                                                    title: collection.title,
                                                                                    text: collection.description
                                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "container",
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: collection.description
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "m-b-30",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    href: "properties/index?collections=" + collection.id,
                                                                                    className: "btn-design-color btn-search-color btn btn-primary w-100",
                                                                                    children: "View Collection"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }, key);
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: collectionsList != null && collectionsList.hasOwnProperty("collections") && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidArray */ .Z.isValidArray(collectionsList.collections) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container text-center p-t-40 p-b-40",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row justify-content-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-auto text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                                        href: "/properties/all",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "btn btn-primary btn-design-color p-4 p-t-10 p-b-10",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidString */ .Z.isValidString(showAllButton) ? showAllButton : "See all villa collections"
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 37048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DestinationsSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75547);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23158);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83974);






function DestinationsSection(param) {
    var destinations = param.destinations, isHomepage = param.isHomepage;
    var getGridArea = function(key) {
        if (key > 5) {
            key = (key + 1) % 6;
        }
        // key++;
        // if(key>6){
        //   key = key - (6 * (key/6));
        // // }
        //
        // console.log('debughere', 'key', key, 'mod', positionCheck)
        if (key == 0) return "boxA";
        else if (key == 1) return "boxB";
        else if (key == 2) return "boxC";
        else if (key == 3) return "boxD";
        else if (key == 4) return "boxE";
        else if (key == 5) return "boxF";
        return "boxUnkown";
    };
    var builderDestinationsBackgroundColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_background_color");
    });
    var showDestinationsInHomepage = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_show_in_homepage");
    });
    var destinationsButtonTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_actions_button");
    });
    var showDestinationsPropertiesCounter = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_destinations_show_properties_counter");
    });
    var classCol = "col-sm-6";
    var itemsPerColumn = 3;
    var destinationColumns = [];
    var currentDestinationColumns = [];
    var column = 1;
    var remainder = null;
    var destinationTwoDimension = [];
    destinations.destinations.map(function(destination, key) {
        var row = Math.floor(key / 6);
        // console.log("destinationHere", destination, column)
        if (destinationTwoDimension[row] == undefined) {
            destinationTwoDimension[row] = [];
        }
        destinationTwoDimension[row].push(destination);
    });
    destinations.destinations.map(function(destination, key) {
        if (isHomepage && key > 5) {
            return;
        }
        column = Math.floor(key / itemsPerColumn);
        remainder = key % itemsPerColumn;
        if (column % 2 == 1) {
            if (remainder == 0) {
                classCol = "col-sm-12";
            } else {
                classCol = "col-sm-6";
            }
        } else {
            if (remainder == 2) {
                classCol = "col-sm-12";
            } else {
                classCol = "col-sm-6";
            }
        // if ( column % 2 == 1 ) {
        //   if ( remainder == 0  ||remainder == 1  ) {
        //     classCol = 'col-sm-6';
        //   } else {
        //     classCol = 'col-sm-12';
        //   }
        // } else {
        //   if ( remainder == 2 ||remainder == 1 ) {
        //     classCol = 'col-sm-6';
        //   } else {
        //     classCol = 'col-sm-12';
        //   }
        }
        destination.className = classCol;
        currentDestinationColumns.push(destination);
        if (currentDestinationColumns.length == 3 && remainder == 2) {
            destinationColumns.push(currentDestinationColumns);
            currentDestinationColumns = [];
        }
    });
    if (currentDestinationColumns.length > 0) {
        destinationColumns.push(currentDestinationColumns);
    }
    return showDestinationsInHomepage == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !isHomepage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-master-lightest p-b-20 p-t-30",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "md-p-l-20 md-p-r-20 xs-no-padding",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row text-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "block-title hint-text no-margin",
                                    children: destinations.main_title
                                }, 3),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-12 col-md-12",
                                    children: destinations.main_subtitle != null && destinations.main_subtitle.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "m-t-5 hidden-xs",
                                        children: destinations.main_subtitle
                                    }, 5) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                }, 4)
                            ]
                        }, 2)
                    }, 1)
                }, 0)
            }, "deistinations_title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "p-t-50 p-b-50 " + (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isHexColor */ .Z.isHexColor(builderDestinationsBackgroundColor) ? "bg-white" : ""),
                style: {
                    background: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isHexColor */ .Z.isHexColor(builderDestinationsBackgroundColor) ? builderDestinationsBackgroundColor : null
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "panel panel-transparent",
                        children: [
                            isHomepage ? destinations.title != null && destinations.title.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "panel-heading",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "panel-title fs-16",
                                        children: destinations.title
                                    }, 8),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "panel-controls",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "/destinations/all",
                                                    children: destinationsButtonTitle
                                                }, 12)
                                            }, 11)
                                        }, 10)
                                    }, 9)
                                ]
                            }, 7) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "panel-heading",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "panel-title fs-16",
                                        children: [
                                            destinations.main_title,
                                            destinations.main_subtitle != null && destinations.main_subtitle.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: destinations.main_subtitle
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                        ]
                                    }, 14),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "panel-controls",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: "/destinations/all",
                                                    children: destinationsButtonTitle
                                                }, 18)
                                            }, 17)
                                        }, 16)
                                    }, 15)
                                ]
                            }, 13) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "panel-body p-t-20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: isHomepage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "custom-css-grid m-b-20",
                                            children: destinations.destinations.map(function(destination, key) {
                                                return key < 6 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        style: {
                                                            gridArea: getGridArea(key)
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "design-box-destination card social-card share full-width",
                                                            style: {
                                                                overflow: "hidden"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "card-content",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                        href: destination.sourcePath,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            alt: "Social post",
                                                                            src: destination.image_thumb
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "card-footer text-left clearfix",
                                                                    children: [
                                                                        showDestinationsPropertiesCounter === "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "text-uppercase hint-text small-text",
                                                                            children: [
                                                                                destination.properties,
                                                                                "+ properties"
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "text-uppercase hint-text small-text line-clamp-1",
                                                                                children: destination.searchFormTitle
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "bold",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                                href: destination.sourcePath,
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    className: "text-master bold",
                                                                                    children: destination.title
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, "destination_item_" + key)
                                                }, key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {}, key);
                                            })
                                        }, 20)
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isValidArray */ .Z.isValidArray(destinationTwoDimension) && destinationTwoDimension.map(function(destinationsInner, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "custom-css-grid m-b-20",
                                                    children: destinationsInner.map(function(destination, key) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                style: {
                                                                    gridArea: getGridArea(key)
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "design-box-destination card social-card share full-width",
                                                                    style: {
                                                                        overflow: "hidden"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "card-content",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                href: destination.sourcePath,
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    alt: "Social post",
                                                                                    src: destination.image_thumb
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "card-footer text-left clearfix",
                                                                            children: [
                                                                                showDestinationsPropertiesCounter === "1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "text-uppercase hint-text small-text",
                                                                                    children: [
                                                                                        destination.properties,
                                                                                        "+ properties"
                                                                                    ]
                                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "text-uppercase hint-text small-text line-clamp-1",
                                                                                        children: destination.searchFormTitle
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                    className: "bold",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                        href: destination.sourcePath,
                                                                                        className: "text-master bold",
                                                                                        children: destination.title
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }, index + "_" + key)
                                                        });
                                                    })
                                                }, index)
                                            });
                                        })
                                    })
                                })
                            }, 19)
                        ]
                    }, 6)
                }, 5)
            }, "deistinations_items")
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 42173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DistinctSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _ReadMoreText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68208);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23158);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83974);






function DistinctSection(param) {
    var distincts = param.distincts, backgroundColor = param.backgroundColor, darkMode = param.darkMode;
    var isMobile = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var numberOfColumns = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_columns");
    });
    var textAlignment = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_text_alignment");
    });
    var sectionTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_title");
    });
    var sectionSubtitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_subtitle");
    });
    var sectionBorders = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_border") == 1 ? true : false;
    });
    var sectionRadius = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_radius");
    });
    var sectionShadow = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_distincts_shadow");
    });
    var textAlignmentClass = textAlignment == "center" ? "text-center" : "text-left";
    var classColumnHandler = function(numberOfColumns) {
        if (distincts.distincts.length < 4) {
            return isMobile ? "col-12 m-b-20" : "col m-b-20";
        }
        if (numberOfColumns == "2") {
            return "col-sm-6 col-md-6 m-b-20";
        }
        if (numberOfColumns == "3") {
            return "col-sm-6 col-md-4 m-b-20";
        }
        if (numberOfColumns == "4") {
            return "col-sm-6 col-md-3 m-b-20";
        }
        if (numberOfColumns == "5") {
            return isMobile ? "col-12 m-b-20" : "col m-b-20";
        }
        if (numberOfColumns == "6") {
            return "col-sm-6 col-md-2 m-b-20";
        }
        return "col-sm-6 col-md-3 m-b-20";
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), classColumn = ref[0], setClassColumn = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setClassColumn(classColumnHandler(numberOfColumns));
    }, [
        numberOfColumns
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            id: "distincts-section",
            className: "p-t-100 p-b-100",
            style: {
                background: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isHexColor */ .Z.isHexColor(backgroundColor) ? backgroundColor : "transparent"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: distincts.title
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: " pb-4 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "undefined p-l-0 p-r-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row justify-content-center w-100 m-0 text-center d-block ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-12 col-sm-10 w-100 text-center d-flex flex-column justify-content-center text-left d-block ",
                                        children: [
                                            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isValidString */ .Z.isValidString(sectionTitle) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "m-t-5 light " + (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .textColor */ .zP)(darkMode),
                                                children: sectionTitle
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "block-title m-t-40 hint-text no-margin justify-content-center text-center d-block " + (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .textColor */ .zP)(darkMode),
                                                children: sectionSubtitle
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "clearfix row",
                            children: distincts.distincts.map(function(distinct, key) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: textAlignmentClass + " " + classColumn,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "clearfix " + (sectionBorders ? " border p-4 h-100 " : " ") + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(sectionRadius) ? " border-radius-" + sectionRadius : " "),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-2x " + distinct.faIcon + " " + (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .textColor */ .zP)(darkMode)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .textColor */ .zP)(darkMode) + " h6 block-title p-b-5 m-t-10 m-b-10 large ",
                                                children: distinct.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "m-b-30 " + (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .textColor */ .zP)(darkMode),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ReadMoreText__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                    letters: 160,
                                                    faIcon: distinct.faIcon,
                                                    title: distinct.title,
                                                    layout: 2,
                                                    text: distinct.description,
                                                    darkMode: darkMode
                                                })
                                            })
                                        ]
                                    })
                                }, key);
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 18364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ IndexSections; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/react-elfsight-widget/dist/react-elfsight-widget.esm.js
var react_elfsight_widget_esm = __webpack_require__(5269);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./components/templates/articles/ArticleCategoriesContainer.tsx
var ArticleCategoriesContainer = __webpack_require__(18630);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ./components/templates/property/content/columned/right/SwipeableDrawerFilters.tsx + 1 modules
var SwipeableDrawerFilters = __webpack_require__(1079);
// EXTERNAL MODULE: ./helpers/class/Calendar.ts
var Calendar = __webpack_require__(74867);
// EXTERNAL MODULE: ./components/templates/index/sections/ProfileSection.tsx
var ProfileSection = __webpack_require__(74810);
// EXTERNAL MODULE: ./components/templates/index/sections/DestinationsSection.tsx
var DestinationsSection = __webpack_require__(37048);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
// EXTERNAL MODULE: ../../shared/node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(27577);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/templates/index/sections/PropertiesSection.tsx







function PropertiesSection(param) {
    var title = param.title, subtitle = param.subtitle, limit = param.limit, backgroundColor = param.backgroundColor, darkMode = param.darkMode, showAll = param.showAll, showAllLabel = param.showAllLabel;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), properties = ref[0], setProperties = ref[1];
    var propertiesData = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesData"];
    });
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var propertiesFetchHandler = function() {
        var params = cloneDeep_default()(propertiesParams);
        params.limit = limit;
        params.is_featured = 1;
        dispatch((0,actions/* fetchPropertiesAction */.SH)(params));
    };
    var propertyItemClass = function(count) {
        if (count % 4 == 0 && count > 0) {
            return "col-md-6";
        }
        if (count % 2 == 0) {
            return "col-md-6";
        }
        return "col-md-4";
    };
    var textColor = function() {
        if (darkMode == 1) {
            return "text-light-color";
        }
        return "";
    };
    (0,react.useEffect)(function() {
        propertiesFetchHandler();
    }, []);
    var getItemUrl = function(property) {
        return Checkers/* default.isValidString */.Z.isValidString(property.sourcePath) ? property.sourcePath : Checkers/* default.isValidString */.Z.isValidString(property.urlSlug) ? property.urlSlug : "/property/" + property.property_id;
    };
    (0,react.useEffect)(function() {
        if (propertiesData != undefined && propertiesData.properties != undefined && Checkers/* default.isValidArray */.Z.isValidArray(propertiesData.properties)) {
            setProperties(propertiesData.properties);
        }
    }, [
        propertiesData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Checkers/* default.isValidString */.Z.isValidString(title) && Checkers/* default.isValidString */.Z.isValidString(subtitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: " p-b-20 p-t-20",
                        style: {
                            background: Checkers/* default.isHexColor */.Z.isHexColor(backgroundColor) ? backgroundColor : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-sm-8 offset-sm-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: textColor() + " block-title m-b-0",
                                            children: subtitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: textColor() + " m-t-5 light",
                                            children: title
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                propertiesData != undefined && properties != undefined && Checkers/* default.isValidArray */.Z.isValidArray(properties) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "container-fluid b-t b-white p-0",
                        style: {
                            background: Checkers/* default.isHexColor */.Z.isHexColor(backgroundColor) ? backgroundColor : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row m-auto",
                            children: properties.map(function(property, index) {
                                if (index > limit - 1) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: getItemUrl(property),
                                        className: propertyItemClass(properties.length) + " text-center bg-success hover-push demo-story-block properties_div",
                                        style: {
                                            height: "350px",
                                            cursor: "pointer",
                                            border: "1px white solid"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hover-backdrop",
                                                style: {
                                                    backgroundImage: "url(" + property.featured_images[0] + ")"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "hover-caption bottom-left bottom-right p-b-40",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "text-white m-b-5 properties_title",
                                                        children: property.property_title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: getItemUrl(property),
                                                        className: "fs-12 hint-text text-white all-caps",
                                                        children: "More details..."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "container-fluid b-t b-white p-0",
                        style: {
                            background: Checkers/* default.isHexColor */.Z.isHexColor(backgroundColor) ? backgroundColor : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                height: 350,
                                className: "col-md-4"
                            })
                        })
                    })
                }),
                showAll == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: " p-b-100 p-t-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-auto text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "btn btn-primary btn-design-color p-4 p-t-10 p-b-10",
                                        href: "/properties/all",
                                        children: Checkers/* default.isValidString */.Z.isValidString(showAllLabel) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: showAllLabel
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Show all"
                                        })
                                    })
                                })
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/templates/index/sections/DistinctSection.tsx
var DistinctSection = __webpack_require__(42173);
// EXTERNAL MODULE: ./components/templates/index/sections/CollectionsSection.tsx
var CollectionsSection = __webpack_require__(34160);
// EXTERNAL MODULE: ./components/templates/properties/partials/TabsContentWrapper.tsx
var TabsContentWrapper = __webpack_require__(3055);
;// CONCATENATED MODULE: ./components/templates/index/sections/ServicesSection.tsx






function ServicesSection(param) {
    var title = param.title, subtitle = param.subtitle, limit = param.limit, backgroundColor = param.backgroundColor, darkMode = param.darkMode, app_data = param.app_data, app = param.app, builder = param.builder, isDesktop = param.isDesktop, viewType = param.viewType, tabbedView = param.tabbedView;
    var dispatch = (0,es/* useDispatch */.I0)();
    var textColor = function() {
        if (darkMode == 1) {
            return "text-light-color";
        }
        return "";
    };
    var ref = (0,react.useState)(true), servicesArrayLoading = ref[0], setServicesArrayLoading = ref[1];
    var ref1 = (0,react.useState)([]), servicesArray = ref1[0], setServicesArray = ref1[1];
    var getTabbedContent = function() {
        var result = [];
        result.push({
            tabId: "included",
            tabTitle: "Included",
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                backgroundColor: backgroundColor,
                textColor: textColor(),
                app_data: app_data,
                app: app,
                builder: builder,
                type: "services",
                serviceType: "1",
                inheritedViewType: viewType,
                articlesLimit: limit,
                content: {
                    "content": {
                        "title": title,
                        "subtitle": subtitle
                    },
                    "articles_categories": []
                },
                isDesktop: isDesktop,
                includeJumbotron: false,
                hideTitle: true,
                itemClassName: "service-item-homepage"
            })
        });
        result.push({
            tabId: "featured",
            tabTitle: "On request",
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                backgroundColor: backgroundColor,
                textColor: textColor(),
                app_data: app_data,
                app: app,
                builder: builder,
                type: "services",
                serviceType: "2",
                inheritedViewType: viewType,
                articlesLimit: limit,
                content: {
                    "content": {
                        "title": title,
                        "subtitle": subtitle
                    },
                    "articles_categories": []
                },
                isDesktop: isDesktop,
                includeJumbotron: false,
                hideTitle: true,
                itemClassName: "service-item-homepage"
            })
        });
        setServicesArrayLoading(false);
        setServicesArray(result);
    };
    (0,react.useEffect)(function() {
        if (servicesArrayLoading) {
            getTabbedContent();
        }
    }, []);
    var viewData = function() {
        if (tabbedView == 1 || tabbedView == "1") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContentWrapper/* default */.Z, {
                    data: servicesArray,
                    ReactComponentsArrayLoading: servicesArrayLoading,
                    tabsContentClass: "m-t-40 m-b-40",
                    backgroundColor: backgroundColor,
                    darkMode: darkMode
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                    backgroundColor: backgroundColor,
                    textColor: textColor(),
                    app_data: app_data,
                    app: app,
                    builder: builder,
                    type: "services",
                    inheritedViewType: viewType,
                    articlesLimit: limit,
                    content: {
                        "content": {
                            "title": title,
                            "subtitle": subtitle
                        },
                        "articles_categories": []
                    },
                    isDesktop: isDesktop,
                    includeJumbotron: false,
                    hideTitle: true,
                    itemClassName: "service-item-homepage"
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Checkers/* default.isValidString */.Z.isValidString(title) || Checkers/* default.isValidString */.Z.isValidString(subtitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: " p-b-20 p-t-100 services-container",
                        style: {
                            background: Checkers/* default.isHexColor */.Z.isHexColor(backgroundColor) ? backgroundColor : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-sm-8 offset-sm-2",
                                    children: [
                                        Checkers/* default.isValidString */.Z.isValidString(title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: textColor() + " m-t-5 light",
                                                children: title
                                            })
                                        }),
                                        Checkers/* default.isValidString */.Z.isValidString(subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                className: textColor() + " block-title m-b-0",
                                                children: subtitle
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                viewData()
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/index/sections/BlogSection.tsx




function BlogSection(param) {
    var title = param.title, subtitle = param.subtitle, limit = param.limit, backgroundColor = param.backgroundColor, darkMode = param.darkMode, showAll = param.showAll, showAllLabel = param.showAllLabel, app_data = param.app_data, app = param.app, builder = param.builder, isDesktop = param.isDesktop, viewType = param.viewType;
    var textColor = function() {
        if (darkMode == 1) {
            return "text-light-color";
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "blog",
                children: [
                    Checkers/* default.isValidString */.Z.isValidString(title) || Checkers/* default.isValidString */.Z.isValidString(subtitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "blog-section p-b-20 p-t-100",
                            style: {
                                background: Checkers/* default.isHexColor */.Z.isHexColor(backgroundColor) ? backgroundColor : ""
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-sm-12",
                                        children: [
                                            Checkers/* default.isValidString */.Z.isValidString(subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    className: textColor() + " block-title m-b-0",
                                                    children: subtitle
                                                })
                                            }),
                                            Checkers/* default.isValidString */.Z.isValidString(title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: textColor() + " m-t-5 light",
                                                    children: title
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                            backgroundColor: backgroundColor,
                            textColor: textColor(),
                            app_data: app_data,
                            app: app,
                            builder: builder,
                            type: "blog",
                            inheritedViewType: viewType,
                            articlesLimit: limit,
                            content: {
                                "content": {
                                    "title": title,
                                    "subtitle": subtitle
                                },
                                "articles_categories": []
                            },
                            isDesktop: isDesktop,
                            includeJumbotron: false,
                            hideTitle: true
                        })
                    }),
                    showAll == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: " p-b-100 p-t-40",
                            style: {
                                background: Checkers/* default.isHexColor */.Z.isHexColor(backgroundColor) ? backgroundColor : ""
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-auto text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-primary btn-design-color p-4 p-t-10 p-b-10",
                                            href: "/blog",
                                            children: Checkers/* default.isValidString */.Z.isValidString(showAllLabel) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: showAllLabel
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "Show all"
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/index/sections/HomepageSections.tsx













var HomepageSections = function(param) {
    var app = param.app, app_data = param.app_data, builder = param.builder, isDesktop = param.isDesktop, isHomepage = param.isHomepage, categoriesContentPromoted = param.categoriesContentPromoted, experienceCategoriesContentPromoted = param.experienceCategoriesContentPromoted, profile = param.profile, destinations = param.destinations, categoriesContentPromoted2 = param.categoriesContentPromoted2, experienceCategoriesContentPromoted2 = param.experienceCategoriesContentPromoted2, distincts = param.distincts, collections = param.collections, experienceCategoriesContentDefault = param.experienceCategoriesContentDefault, categoriesContentDefault = param.categoriesContentDefault;
    var showExperiencesSection = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_experiences_show_in_homepage");
    });
    var showProfileSection = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_profile_show_in_homepage");
    });
    var showPropertiesSection = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_featured_properties_enabled");
    });
    var showDistincsSection = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_distincts_show_in_homepage");
    });
    var propertiesSectionTitle = app.builder.builder_homepage_featured_properties_title;
    var propertiesSectionDescription = app.builder.builder_homepage_featured_properties_description;
    var propertiesSectionFeaturedLimit = app.builder.builder_homepage_featured_properties_number;
    var propertiesSectionSectionColor = app.builder.builder_homepage_featured_properties_section_color;
    var propertiesSectionDarkMode = app.builder.builder_homepage_featured_properties_dark_mode;
    var propertiesSectionShowAllButton = app.builder.builder_homepage_featured_properties_show_all_button;
    var propertiesSectionShowAllButtonLabel = app.builder.builder_homepage_featured_properties_show_all_button_label;
    var distinctsBackgroundColor = app.builder.builder_homepage_distincts_background_color;
    var distinctsDarkMode = app.builder.builder_homepage_distincts_dark_mode;
    var showServicesSection = app.builder.builder_homepage_services_enabled;
    var servicesSectionTitle = app.builder.builder_homepage_services_title;
    var servicesSectionDescription = app.builder.builder_homepage_services_description;
    var servicesSectionLimit = app.builder.builder_homepage_services_number;
    var servicesSectionSectionColor = app.builder.builder_homepage_services_color;
    var servicesSectionDarkMode = app.builder.builder_homepage_services_dark_mode;
    var servicesSectionViewType = app.servicesViewType.toString();
    var servicesSectionTabbedView = app.builder.builder_homepage_services_tabs;
    var showBlogSection = app.builder.builder_homepage_blog_enabled;
    var blogSectionTitle = app.builder.builder_homepage_blog_title;
    var blogSectionDescription = app.builder.builder_homepage_blog_description;
    var blogSectionFeaturedLimit = app.builder.builder_homepage_blog_post_number;
    var blogSectionSectionColor = app.builder.builder_homepage_blog_section_color;
    var blogSectionDarkMode = app.builder.builder_homepage_blog_dark_mode;
    var blogSectionShowAllButton = app.builder.builder_homepage_blog_show_all_button;
    var blogSectionShowAllButtonLabel = app.builder.builder_homepage_blog_show_all_button_label;
    var blogSectionViewType = app.builder.builder_homepage_blog_post_view_type;
    var collectionItemsBtnLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_experiences_btn_label");
    });
    var homepageSectionsEnabled = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_homepage_enable_sections") == 1;
    });
    var homepageSections = app.homepageSections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: homepageSections && Checkers/* default.isValidArray */.Z.isValidArray(homepageSections) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: homepageSections.map(function(section) {
                if (!section.isActive) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "key-section");
                }
                switch(section.type){
                    case "SYSTEM_HOMEPAGE_CATEGORIES_PROMOTED":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && categoriesContentPromoted != null && categoriesContentPromoted.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: categoriesContentPromoted.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                                        app_data: app_data,
                                                        app: app,
                                                        builder: builder,
                                                        type: "category",
                                                        content: item,
                                                        isDesktop: isDesktop,
                                                        articlesCategories: null,
                                                        categoryIdInhrerited: item.id,
                                                        includeJumbotron: false,
                                                        includeTitle: !item.hide_title
                                                    }, "categories-content-container-" + index)
                                                }, "categories-content-fragment-" + index)
                                            });
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_EXPERIENCES_PROMOTED":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    showExperiencesSection == 1 && isHomepage && experienceCategoriesContentPromoted != null && experienceCategoriesContentPromoted.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_PROFILE":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showProfileSection == 1 && profile && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSection["default"], {
                                            profile: profile
                                        }, "overview_profile")
                                    })
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_DESTINATIONS":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    destinations != null && destinations.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationsSection["default"], {
                                            destinations: destinations,
                                            isHomepage: isHomepage
                                        }, "destinations")
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_PROPERTIES":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showPropertiesSection == 1 && profile && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertiesSection, {
                                            title: propertiesSectionTitle,
                                            subtitle: propertiesSectionDescription,
                                            limit: propertiesSectionFeaturedLimit,
                                            backgroundColor: propertiesSectionSectionColor,
                                            darkMode: propertiesSectionDarkMode,
                                            showAll: propertiesSectionShowAllButton,
                                            showAllLabel: propertiesSectionShowAllButtonLabel
                                        }, "properties_section")
                                    })
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_CATEGORIES_PROMOTED_2":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && categoriesContentPromoted2 != null && categoriesContentPromoted2.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: categoriesContentPromoted2.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                                        app_data: app_data,
                                                        app: app,
                                                        builder: builder,
                                                        type: "category",
                                                        content: item,
                                                        isDesktop: isDesktop,
                                                        articlesCategories: null,
                                                        categoryIdInhrerited: item.id,
                                                        includeJumbotron: false,
                                                        includeTitle: !item.hide_title
                                                    }, "categories-content-promoted2-container-" + index)
                                                })
                                            }, "categories-content-promoted2-fragment-" + index);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_EXPERIENCES_PROMOTED_2":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showExperiencesSection == 1 && experienceCategoriesContentPromoted2 != null && experienceCategoriesContentPromoted2.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: experienceCategoriesContentPromoted2.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                                        app_data: app_data,
                                                        app: app,
                                                        builder: builder,
                                                        type: "experiences",
                                                        content: item,
                                                        isDesktop: isDesktop,
                                                        articlesCategories: null,
                                                        categoryIdInhrerited: item.id,
                                                        includeJumbotron: false,
                                                        includeTitle: !item.hide_title
                                                    }, "categories-content-promoted1-container-" + index)
                                                })
                                            }, "categories-content-promoted1-fragment-" + index);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_DISTINCT_SECTIONS":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showDistincsSection == 1 && distincts && distincts.distincts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DistinctSection["default"], {
                                            distincts: distincts,
                                            backgroundColor: distinctsBackgroundColor,
                                            darkMode: distinctsDarkMode
                                        }, "distincts")
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_COLLECTIONS_DEFAULT":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && collections && collections.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionsSection["default"], {
                                            app: app,
                                            builder: builder,
                                            app_data: app_data,
                                            enableReadMore: false,
                                            collectionsList: collections
                                        }, "collections")
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_EXPERIENCES_DEFAULT":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showExperiencesSection == 1 && experienceCategoriesContentDefault != null && experienceCategoriesContentDefault.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: experienceCategoriesContentDefault.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                                        app_data: app_data,
                                                        app: app,
                                                        builder: builder,
                                                        type: "experiences",
                                                        content: item,
                                                        isDesktop: isDesktop,
                                                        articlesCategories: null,
                                                        categoryIdInhrerited: item.id,
                                                        includeJumbotron: false,
                                                        includeTitle: !item.hide_title,
                                                        itemClassName: "experience-design-box",
                                                        showAllLabel: collectionItemsBtnLabel
                                                    }, "exp-categories-content-container-" + index)
                                                })
                                            }, "exp-categories-content-fragment-" + index);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_SERVICES":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showServicesSection == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesSection, {
                                            title: servicesSectionTitle,
                                            subtitle: servicesSectionDescription,
                                            limit: servicesSectionLimit,
                                            backgroundColor: servicesSectionSectionColor,
                                            darkMode: servicesSectionDarkMode,
                                            viewType: servicesSectionViewType,
                                            tabbedView: servicesSectionTabbedView,
                                            app_data: app_data,
                                            app: app,
                                            builder: builder,
                                            isDesktop: isDesktop
                                        }, "services_section")
                                    })
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_CATEGORIES_DEFAULT":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && categoriesContentDefault != null && categoriesContentDefault.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: categoriesContentDefault.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                                        app_data: app_data,
                                                        app: app,
                                                        builder: builder,
                                                        type: "category",
                                                        content: item,
                                                        isDesktop: isDesktop,
                                                        articlesCategories: null,
                                                        categoryIdInhrerited: item.id,
                                                        includeJumbotron: false,
                                                        includeTitle: !item.hide_title
                                                    }, "ccd-" + index)
                                                })
                                            }, "fragment" + index);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_BLOG":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    isHomepage && showBlogSection == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogSection, {
                                            title: blogSectionTitle,
                                            subtitle: blogSectionDescription,
                                            limit: blogSectionFeaturedLimit,
                                            backgroundColor: blogSectionSectionColor,
                                            darkMode: blogSectionDarkMode,
                                            showAll: blogSectionShowAllButton,
                                            showAllLabel: blogSectionShowAllButtonLabel,
                                            viewType: blogSectionViewType,
                                            app_data: app_data,
                                            app: app,
                                            builder: builder,
                                            isDesktop: isDesktop
                                        }, "blog_section")
                                    })
                                ]
                            }, "key-" + section.type);
                        }
                    case "SYSTEM_HOMEPAGE_HTML":
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    section.hasOwnProperty("urlSlug") && Checkers/* default.isValidString */.Z.isValidString(section.urlSlug) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: section.urlSlug
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: section.content
                                        }
                                    })
                                ]
                            }, "key-" + section.type);
                        }
                    default:
                        {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "key-" + section.type);
                        }
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                showExperiencesSection == 1 && isHomepage && experienceCategoriesContentPromoted != null && experienceCategoriesContentPromoted.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && categoriesContentPromoted != null && categoriesContentPromoted.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: categoriesContentPromoted.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                    app_data: app_data,
                                    app: app,
                                    builder: builder,
                                    type: "category",
                                    content: item,
                                    isDesktop: isDesktop,
                                    articlesCategories: null,
                                    categoryIdInhrerited: item.id,
                                    includeJumbotron: false,
                                    includeTitle: !item.hide_title
                                }, "ccp-" + index)
                            })
                        }, "fragment" + index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showProfileSection == 1 && profile && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSection["default"], {
                        profile: profile
                    }, "overview_profile")
                }),
                destinations != null && destinations.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationsSection["default"], {
                        destinations: destinations,
                        isHomepage: isHomepage
                    }, "destinations-default")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showPropertiesSection == 1 && profile && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertiesSection, {
                        title: propertiesSectionTitle,
                        subtitle: propertiesSectionDescription,
                        limit: propertiesSectionFeaturedLimit,
                        backgroundColor: propertiesSectionSectionColor,
                        darkMode: propertiesSectionDarkMode,
                        showAll: propertiesSectionShowAllButton,
                        showAllLabel: propertiesSectionShowAllButtonLabel
                    }, "properties_section")
                }),
                isHomepage && categoriesContentPromoted2 != null && categoriesContentPromoted2.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: categoriesContentPromoted2.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                    app_data: app_data,
                                    app: app,
                                    builder: builder,
                                    type: "category",
                                    content: item,
                                    isDesktop: isDesktop,
                                    articlesCategories: null,
                                    categoryIdInhrerited: item.id,
                                    includeJumbotron: false,
                                    includeTitle: !item.hide_title
                                }, "ccp2-" + index)
                            })
                        }, "fr" + index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showExperiencesSection == 1 && experienceCategoriesContentPromoted2 != null && experienceCategoriesContentPromoted2.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: experienceCategoriesContentPromoted2.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                    app_data: app_data,
                                    app: app,
                                    builder: builder,
                                    type: "experiences",
                                    content: item,
                                    isDesktop: isDesktop,
                                    articlesCategories: null,
                                    categoryIdInhrerited: item.id,
                                    includeJumbotron: false,
                                    includeTitle: !item.hide_title
                                }, "eccp2- " + index)
                            })
                        }, "fragment" + index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showDistincsSection == 1 && distincts && distincts.distincts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DistinctSection["default"], {
                        distincts: distincts,
                        backgroundColor: distinctsBackgroundColor,
                        darkMode: distinctsDarkMode
                    }, "distincts")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && collections && collections.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionsSection["default"], {
                        app: app,
                        builder: builder,
                        app_data: app_data,
                        enableReadMore: false,
                        collectionsList: collections
                    }, "collections")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showExperiencesSection == 1 && experienceCategoriesContentDefault != null && experienceCategoriesContentDefault.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: experienceCategoriesContentDefault.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                    app_data: app_data,
                                    app: app,
                                    builder: builder,
                                    type: "experiences",
                                    content: item,
                                    isDesktop: isDesktop,
                                    articlesCategories: null,
                                    categoryIdInhrerited: item.id,
                                    includeJumbotron: false,
                                    includeTitle: !item.hide_title,
                                    itemClassName: "experience-design-box"
                                }, "eccp- " + index)
                            })
                        }, "fragment" + index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showServicesSection == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesSection, {
                        title: servicesSectionTitle,
                        subtitle: servicesSectionDescription,
                        limit: servicesSectionLimit,
                        backgroundColor: servicesSectionSectionColor,
                        darkMode: servicesSectionDarkMode,
                        viewType: servicesSectionViewType,
                        tabbedView: servicesSectionTabbedView,
                        app_data: app_data,
                        app: app,
                        builder: builder,
                        isDesktop: isDesktop
                    }, "services_section")
                }),
                isHomepage && categoriesContentDefault != null && categoriesContentDefault.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: categoriesContentDefault.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                    app_data: app_data,
                                    app: app,
                                    builder: builder,
                                    type: "category",
                                    content: item,
                                    isDesktop: isDesktop,
                                    articlesCategories: null,
                                    categoryIdInhrerited: item.id,
                                    includeJumbotron: false,
                                    includeTitle: !item.hide_title
                                }, "cc- " + index)
                            })
                        }, "fragment" + index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                isHomepage && showBlogSection == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogSection, {
                        title: blogSectionTitle,
                        subtitle: blogSectionDescription,
                        limit: blogSectionFeaturedLimit,
                        backgroundColor: blogSectionSectionColor,
                        darkMode: blogSectionDarkMode,
                        showAll: blogSectionShowAllButton,
                        showAllLabel: blogSectionShowAllButtonLabel,
                        viewType: blogSectionViewType,
                        app_data: app_data,
                        app: app,
                        builder: builder,
                        isDesktop: isDesktop
                    }, "blog_section")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/templates/index/sections/IndexSections.tsx











var Header = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 60314));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60314)
            ];
        }
    }
});
var Jumbotron = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 69350));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69350)
            ];
        }
    },
    suspense: true
});
var BookingSearchBar = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26171)
            ];
        }
    },
    suspense: true
});
var BottomSections = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64481));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64481)
            ];
        }
    },
    suspense: true
});
var IndexSections_DistinctSection = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 42173));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42173)
            ];
        }
    },
    suspense: true
});
var IndexSections_ProfileSection = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 74810));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74810)
            ];
        }
    },
    suspense: true
});
var IndexSections_DestinationsSection = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 37048));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37048)
            ];
        }
    },
    suspense: true
});
var IndexSections_CollectionsSection = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34160));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34160)
            ];
        }
    },
    suspense: true
});
function IndexSections(param) {
    var isDesktop = param.isDesktop, html_sections = param.html_sections, app_data = param.app_data, head = param.head, app = param.app, builder = param.builder, navigation = param.navigation, content = param.content, locations = param.locations, footer = param.footer, distincts = param.distincts, profile = param.profile, destinations = param.destinations, collections = param.collections, isHomepage = param.isHomepage, _isExperiencesPage = param.isExperiencesPage, isExperiencesPage = _isExperiencesPage === void 0 ? false : _isExperiencesPage, categoriesContentDefault = param.categoriesContentDefault, categoriesContentPromoted = param.categoriesContentPromoted, categoriesContentPromoted2 = param.categoriesContentPromoted2, experienceCategoriesContentDefault = param.experienceCategoriesContentDefault, experienceCategoriesContentPromoted = param.experienceCategoriesContentPromoted, experienceCategoriesContentPromoted2 = param.experienceCategoriesContentPromoted2, htmlSections = param.htmlSections;
    var header_section = true;
    var jumbotron_section = true;
    var contact_section = true;
    var footer_section = true;
    // if ( html_sections != null ) {
    //   // header_section = false;
    //   // jumbotron_section = false;
    //   // contact_section = false;
    //   // footer_section = false;
    //   // html_sections.forEach( ( obj ) => {
    //   //
    //   //   if ( obj.app_section_type == 'SYSTEM_HEADER' ) {
    //   //     header_section = true;
    //   //   }
    //   //   if ( obj.app_section_type == 'SYSTEM_JUMBOTRON' ) {
    //   //     jumbotron_section = true;
    //   //   }
    //   //   if ( obj.app_section_type == 'SYSTEM_CONTACT' ) {
    //   //     contact_section = true;
    //   //   }
    //   //   if ( obj.app_section_type == 'SYSTEM_FOOTER' ) {
    //   //     footer_section = true;
    //   //   }
    //   // });
    // }
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    var isHomePageRedux = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHomepage"];
    });
    var textColor = function(dark_text) {
        if (dark_text != undefined && dark_text != false) {
            return "";
        }
        return "text-light-color";
    };
    var contentTypeHandler = function(type) {
        return Checkers/* default.isValidString */.Z.isValidString(type) && type;
    };
    Calendar/* default.setProps */.Z.setProps({
        isDesktop: isDesktop,
        html_sections: html_sections,
        app_data: app_data,
        head: head,
        app: app,
        builder: builder,
        navigation: navigation,
        content: content,
        locations: locations,
        footer: footer,
        distincts: distincts,
        profile: profile,
        destinations: destinations,
        collections: collections,
        isHomepage: isHomepage,
        categoriesContentDefault: categoriesContentDefault,
        categoriesContentPromoted: categoriesContentPromoted,
        categoriesContentPromoted2: categoriesContentPromoted2
    });
    var calendarMaterialTheme = Calendar/* default.getCalendarMaterialTheme */.Z.getCalendarMaterialTheme;
    var calendar = {
        customTheme: calendarMaterialTheme
    };
    var homepageSections = app.homepageSections;
    var searchBarInDrawer = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_search_in_drawer"));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            isHomepage && jumbotron_section ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Jumbotron, {
                            withMotto: true,
                            isDesktop: isDesktop,
                            isManager: app_data.is_manager,
                            content: content.details,
                            pageTitle: head.data.title,
                            motto: content.details.motto,
                            album: content.album,
                            designMode: app.designMode,
                            logoDecoration: app.logoDecoration,
                            logoDecorationOriginWidth: app.logoDecorationOriginWidth,
                            logoDecorationOriginHeight: app.logoDecorationOriginHeight,
                            jumbotronHeight: app.jumbotronHeight,
                            jumbotronAutoplay: app.jumbotronAutoplay,
                            jumbotronOverlayOpacity: app.jumbotronOverlayOpacity,
                            jumbotronTextAlign: app.jumbotronTextAlign,
                            jumbotronTextColor: app.jumbotronTextColor,
                            sliderTitleShadow: app.sliderTitleShadow,
                            sliderTitleBold: app.sliderTitleBold,
                            sliderThumbnails: app.sliderThumbnails,
                            video: content.details.hasOwnProperty("video") && content.details.video != null ? content.details.video.length > 0 ? content.details.video : null : null,
                            homeTitle: app.hasOwnProperty("homeTitle") && app.homeTitle != null ? app.homeTitle.length > 0 ? app.homeTitle : null : null,
                            homeSubtitle: app.hasOwnProperty("homeSubtitle") && app.homeSubtitle != null ? app.homeSubtitle.length > 0 ? app.homeSubtitle : null : null,
                            sliderSearchBar: app.enableBooking && !app.bookingSearchbarWidth && !app.bookingSearchbarPosition,
                            searchbarRadius: app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null,
                            searchbarShadow: app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null,
                            bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false
                        }, "jubmotron")
                    }),
                    (isDesktop || !searchBarInDrawer) && app.enableBooking ? !app.bookingSearchbarWidth && app.bookingSearchbarPosition ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "booking-bar position-relative z-index-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container position-absolute start-50 translate-middle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "hidden",
                                    children: "Booking Bar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSearchBar, {
                                        isDesktop: isDesktop,
                                        isManager: app_data.is_manager,
                                        designMode: app.designMode,
                                        searchbarThemeColor: app.searchbarThemeColor,
                                        underSliderContained: true,
                                        searchbarRadius: app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null,
                                        searchbarShadow: app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null,
                                        bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false,
                                        isHomePage: true
                                    }, "BookingSearchBar")
                                })
                            ]
                        })
                    }) : app.bookingSearchbarWidth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSearchBar, {
                            isDesktop: isDesktop,
                            isManager: app_data.is_manager,
                            fullWidthBar: true,
                            designMode: app.designMode,
                            bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false,
                            searchbarThemeColor: app.searchbarThemeColor != null ? app.searchbarThemeColor : null,
                            searchbarBgColor: app.searchbarBgColor != null && app.searchbarBgColor != "" ? app.searchbarBgColor : null,
                            position: app.bookingSearchbarPosition,
                            isHomePage: true
                        }, "BookingSearchBar")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    !isDesktop && searchBarInDrawer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawerFilters/* default */.Z, {
                            forHomepage: isHomepage,
                            calendar: calendar
                        }, "SwipeableDrawerFilters")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            isHomepage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageSections, {
                app: app,
                app_data: app_data,
                builder: builder,
                isDesktop: isDesktop,
                isHomepage: isHomepage,
                categoriesContentPromoted: categoriesContentPromoted,
                experienceCategoriesContentPromoted: experienceCategoriesContentPromoted,
                profile: profile,
                destinations: destinations,
                categoriesContentPromoted2: categoriesContentPromoted2,
                experienceCategoriesContentPromoted2: experienceCategoriesContentPromoted2,
                distincts: distincts,
                collections: collections,
                experienceCategoriesContentDefault: experienceCategoriesContentDefault,
                categoriesContentDefault: categoriesContentDefault
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            isHomepage && html_sections != null && html_sections != undefined ? html_sections.map(function(section, index) {
                if (section.app_section_position == "after_jumbotron") {
                    if (section.app_section_content.length > 0) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: section.app_section_content
                                }
                            }, index)
                        }, "fr" + index);
                    }
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            !isHomepage && destinations != null && destinations.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexSections_DestinationsSection, {
                    destinations: destinations,
                    isHomepage: isHomepage
                }, "destinations")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            isExperiencesPage && experienceCategoriesContentDefault != null && experienceCategoriesContentDefault.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: experienceCategoriesContentDefault.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                                app_data: app_data,
                                app: app,
                                builder: builder,
                                type: "experiences",
                                content: item,
                                isDesktop: isDesktop,
                                articlesCategories: null,
                                categoryIdInhrerited: item.id,
                                includeJumbotron: false,
                                includeTitle: !item.hide_title,
                                itemClassName: "experience-design-box"
                            }, index)
                        })
                    }, "fragment" + index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            !(homepageSections && Checkers/* default.isValidArray */.Z.isValidArray(homepageSections)) && html_sections != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-fluid overflow-hidden",
                    children: html_sections.map(function(section, key) {
                        return section.app_section_content != null ? section.app_section_content.includes("elfsight-app") ? section.app_section_content.split("elfsight-app-")[1] != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_elfsight_widget_esm/* ElfsightWidget */.j, {
                            widgetID: section.app_section_content.split("elfsight-app-")[1].split('"></div>')[0]
                        }, "elfsign-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "elfsight-fragment" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "elfsight-fragment" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "elfsight-fragment" + key);
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "elfsight-fragment")
        ]
    }, "page");
}


/***/ }),

/***/ 74810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProfileSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87091);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96350);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23158);






function ProfileSection(param) {
    var profile = param.profile;
    var getEmbedUrl = function getEmbedUrl(url) {
        var match = url.match(/(?:v=|\/shorts\/|\/embed\/|youtu\.be\/)([^?&/]+)/);
        return match ? "https://www.youtube.com/embed/".concat(match[1]) : null;
    };
    var profileViewType = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_4__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_profile_view_type");
    });
    var isColumned = profileViewType == "1";
    var isCentered = profileViewType != "1";
    var extraClasses = isCentered ? " text-center" : " text-full-alignment";
    var embedUrl = profile && profile.video && profile.video;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isColumned == true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-master-lightest p-b-100 p-t-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "block-title hint-text no-margin",
                            children: profile.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: embedUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-sm-6 pe-sm-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "m-t-5 hidden-xs",
                                                children: profile.motto
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "p-t-0  md-p-t-15" + extraClasses,
                                                dangerouslySetInnerHTML: {
                                                    __html: profile.description
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-6 no-padding xs-p-l-15 xs-p-r-15 d-flex justify-content-center align-items-center " + extraClasses,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                            src: getEmbedUrl(embedUrl),
                                            allowFullScreen: true,
                                            height: "315",
                                            title: "Video Player",
                                            className: "w-100 rounded m-t-20 mr-sm-3"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-5 col-md-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "m-t-5 hidden-xs",
                                            children: profile.motto
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-7 col-md-8 no-padding xs-p-l-15 xs-p-r-15 d-flex justify-content-center align-items-center " + extraClasses,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "p-t-0 p-l-35 md-p-l-5 md-p-t-15" + extraClasses,
                                            dangerouslySetInnerHTML: {
                                                __html: profile.description
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: " p-b-100 p-t-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-sm-8 offset-sm-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    className: "block-title m-b-0",
                                    children: profile.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "m-t-5 light",
                                    children: profile.motto
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "m-t-20" + extraClasses,
                                    dangerouslySetInnerHTML: {
                                        __html: profile.description
                                    }
                                }),
                                embedUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                    src: getEmbedUrl(embedUrl),
                                    allowFullScreen: true,
                                    height: "315",
                                    title: "Video Player",
                                    className: "w-100 rounded m-t-20"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faArrowDown */ .r5q,
                                    className: "fs-24 m-t-20",
                                    style: {
                                        color: "#d1d1d1"
                                    }
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}


/***/ })

}]);